'use es6';

import { bender } from 'legacy-hubspot-bender-context'; // import-eslint-disable-line

export const getIconUrl = (set, iconName, style = 'default') => {
  return `${bender.staticDomainPrefix}/content-icons-ui/${bender.depVersions['content-icons-ui']}/images/${set}/${iconName}/${style}.svg`;
};